<template>
  <b-container fluid>
        <b-row>
            <b-col cols="12" md="4">
                <div class="login__description">
                    <div style="width: 80%">
                        <h3 style="font-weight: normal">
                            <img :src="$cdn + '/icons/icon-person-login.svg'" alt="icono persona">
                            Bienvenido!
                        </h3>
                        <p style="font-weight: normal">Estimado Proveedor. <br> Al ingresar a la plataforma podrás acceder a diferentes servicios en línea.</p>
                        <p style="font-weight: normal">Si quieres conocer nuestros procesos haz clic en <a href="/ofertas/ofertasPublicas" style="font-size: 1.8rem" target="_blank" rel="noopener noreferrer"><b-icon icon="link45deg" class="mr-2"></b-icon>Oportunidades de Negocio</a></p>
                      <p><a href="https://proveedores.cajasan.com/static/cdn/INSTRUCTIVO_CONSULTA_PAGOS_FACTURAS.pdf" target="_blank">Haz clic aquí para descargar el instructivo para consultar los pagos a proveedores.</a></p>

                    </div>
                </div>
            </b-col>
        <b-col cols="12" md="4">
            <div class="login__form">
                <div class="inputs mb-5">
                    <input v-model="usuario" placeholder="Ingrese su email" type="text" :class="class_usuario ? '' : 'invalid'">
                </div>
                <div class="inputs password mb-3">
                    <input v-model="clave" placeholder="Ingrese su clave de este administrador" type="password" id="claveUsuario" :class="class_clave ? '' : 'invalid'">
                    <button class="show" @click="verClave()">
                        <b-icon icon="eye-fill"></b-icon>
                        <b-icon icon="eye-slash-fill"></b-icon>
                    </button>
                </div>
                <div class="login__recovery mb-5">
                    <a href="#" rel="noopener noreferrer" @click="$router.push('/recuperar')">Recuperar usuario</a>
                </div>
                <div class="login__terms">
                <div class="term">
                <div class="input--check">
                    <input v-model="terminos" type="checkbox" value="true" id="terminos"/>
                    <label class="checkbox" for="terminos"></label>
                </div>
                <a href="https://cajasan.com/aviso-privacidad" target="_blank" rel="noopener noreferrer">He leído y conozco los Términos de uso</a>
                </div>
                <div class="term">
                <div class="input--check">
                    <input v-model="politicas" type="checkbox" value="true" id="politicas"/>
                    <label class="checkbox" for="politicas"></label>
                </div>
                <a href="https://cajasan.com/documentos-transparencia/politica-tratamiento-de-informacion-cajasan" target="_blank" rel="noopener noreferrer">He leído, conozco y acepto la Política de Tratamiento de Datos de Cajasan</a>
                </div>
            </div>
            <button class="button-principal mb-5" @click="iniciar_session()">Iniciar sesión</button>
            <div class="login__question mb-5">
                <p>¿No tienes usuario?</p>
                <p><a href="https://proveedores.cajasan.com/static/cdn/INSTRUCTIVO_REGISTRO_PROVEEDORES.pdf" target="_blank">Haz clic aquí para descargar el instructivo de registro</a></p>
            </div>
            <button class="button-secundary" @click="$router.push('/registro')">Registrarme como usuario</button>
            </div>
        </b-col>
        <b-col>
            <div class="login__logo">
            <img :src="$cdn + '/logos/logo-Cajasan-azul-slogan.png'" alt="Logo Cajasan">
            </div>
        </b-col>
        </b-row>
    </b-container>
</template>

<script>
import notify from "../../../../cajasan.ui/src/src/components/ui/notify";
import store from "../../../../cajasan.ui/src/src/store"
export default {
  name: 'formLogin',
  data () {
    return {
      usuario: '',
      class_usuario: true,
      clave: '',
      class_clave: true,
      terminos: null,
      politicas: null
    }
  },
  components: {

  },
  watch: {
    usuario() {
        let usuario = this.validarEmail(this.usuario);

        if (usuario == false) {
            this.class_usuario = false;
        } else {
            this.class_usuario = true;
        }
    },

    clave() {
        var value = this.clave;

        if (value.toString().trim() == "") {
            this.class_clave = false;
        } else {
            this.class_clave = true;
        }
    }
  },
  methods: {
    verClave: function () {
      var inputClave = document.getElementById('claveUsuario')
      var botonClave = document.getElementsByClassName('show')

      botonClave[0].classList.toggle('activo')

      if (inputClave.type === 'password') {
        inputClave.type = 'text'
      } else {
        inputClave.type = 'password'
      }
    },

    stateChange: function (state) {
      this.$emit('stateChange', state)
    },

    iniciar_session: function () {
      if(this.usuario != '' && this.clave != '' && this.terminos==true && this.politicas==true){
        store.commit('setCargando', { estado: true })
        let datos = {
          email: this.usuario,
          clave: this.clave
        }
        this.$store.dispatch('login', datos).then(response => {
          store.commit('setCargando', { estado: false })
          if(response.CODE == '1'){
            let data = response.RESULT
            data.email = this.usuario
            localStorage.setItem('infoUsuario', JSON.stringify(data))
            localStorage.setItem('idmpu', 'bm9lc2FkbWlu')
            window.location.href = '/dashboard'
          }else {
            this.$swal ('Usuario / Clave incorrectos, o la cuenta está inactiva')
          }
        })
      }else{
        this.$swal('Faltan datos por llenar o seleccionar')
      }

    },

    validarEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
}
</script>
